import { useCallback } from "react";
import { useCurrency } from "@/hooks/useCurrency";
import { useLocale } from "@/store/locale-store";
import type { GameResell } from "@/models/GameResell";
import { GameUtil } from "@/utils/GameUtil";

/** 지금 사용자(통화 · 국가)가 이 게임 키를 단독으로 살 수 있나 — 판정은 `GameUtil.canBuyGameKey` 한 곳. */
export function useCanBuyGameKey(gameResell: GameResell | null | undefined) {
  const currency = useCurrency();
  const { countryCode } = useLocale();
  return GameUtil.canBuyGameKey(gameResell, currency, countryCode);
}

/** 게임 목록에서 단독으로 살 수 있는 게임 키만 남기는 판정(목록 필터용). */
export function useCanBuyGameKeyFn() {
  const currency = useCurrency();
  const { countryCode } = useLocale();
  return useCallback(
    (gameResell: GameResell | null | undefined) =>
      GameUtil.canBuyGameKey(gameResell, currency, countryCode),
    [currency, countryCode],
  );
}
